import { render } from "./TraineeIssuesDisplay.vue?vue&type=template&id=0ec8b275&scoped=true"
import script from "./TraineeIssuesDisplay.vue?vue&type=script&lang=js"
export * from "./TraineeIssuesDisplay.vue?vue&type=script&lang=js"

import "./TraineeIssuesDisplay.vue?vue&type=style&index=0&id=0ec8b275&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec8b275"]])

export default __exports__